import { type FC } from 'react';
import { FormattedMessage, useIntl } from 'dibs-react-intl';
import { GridRow, GridCol } from 'dibs-elements/exports/Grid';

import { IphoneSharedAppStoreLink } from '../IphoneSharedAppStoreLink/IphoneSharedAppStoreLink';
import { IphoneSharedLinkTextingWidget } from '../IphoneSharedLinkTextingWidget/IphoneSharedLinkTextingWidget';
import copy from '../helpers/copy';

import styles from './IphoneRespLayout.scss';

export const IphoneRespLayout: FC = () => {
    const intl = useIntl();

    return (
        <GridRow>
            <GridCol desktop={6} mobile={6}>
                <h1 className={styles.h1}>
                    <FormattedMessage
                        id="IphoneRespLayout.h1"
                        defaultMessage="The world’s {italic} are right at your fingertips"
                        values={{
                            italic: (
                                <span className={styles.h1Italic}>
                                    <FormattedMessage
                                        id="IphoneRespLayout.h1Italic"
                                        defaultMessage="most beautiful things"
                                    />
                                </span>
                            ),
                        }}
                    />
                </h1>

                <IphoneSharedAppStoreLink className={styles.respAppStoreLink} />

                <div className={styles.dowloadHeading}>
                    <FormattedMessage
                        id="IphoneRespLayout.downloadHeading"
                        defaultMessage="Download the 1stDibs App"
                    />
                </div>

                <div className={styles.dowloadWrapper}>
                    <IphoneSharedAppStoreLink className={styles.desktopAppStoreLink} />
                    <IphoneSharedLinkTextingWidget
                        widgetClassNames={{
                            inner: styles.widgetInner,
                            inputWrapper: styles.widgetInputWrapper,
                        }}
                    />
                </div>

                <div className={styles.descriptionHeader}>{copy.descriptionHeader}</div>
                <div className={styles.description}>{copy.description}</div>
            </GridCol>
            <GridCol desktop={6} mobile={6}>
                <img
                    className={styles.iphonesImg}
                    src="//a.1stdibscdn.com/dist/adhoc/appdownloads/iphone-ipad.png?height=880"
                    alt={intl.formatMessage(copy.iPhonesImg)}
                />
            </GridCol>
        </GridRow>
    );
};
